import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from '../../../theme';
import { Flex } from '../Flex';
import { Text } from '../Text';
const rotate = keyframes `
  100% { transform: rotate(360deg); }
`;
const dash = keyframes `
  0% {
    stroke-dasharray: 1,150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90,150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90,150;
    stroke-dashoffset: -124;
  }
`;
const SvgContainer = styled.svg `
  animation: ${rotate} 2s linear infinite;
  z-index: inherit;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  margin: 0 ${({ hasText }) => (hasText ? '0' : 'auto')};
  display: block;
`;
const Circle = styled.circle `
  stroke-dasharray: 1, 150;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: ${dash} 1.5s ease-in-out infinite;
`;
export const Spinner = ({ size, color, text, testId }) => {
    const spinnerColor = color || theme.colors.baseText;
    return (_jsxs(Flex, Object.assign({ sx: {
            alignItems: 'center',
            justifyContent: 'center',
        }, "data-testid": testId }, { children: [_jsx(SvgContainer, Object.assign({ viewBox: "0 0 44 44", size: size, hasText: Boolean(text) }, { children: _jsx(Circle, { cx: "22", cy: "22", r: "20", fill: "none", strokeWidth: "4", stroke: spinnerColor }) })), text && (_jsx(Text, Object.assign({ pl: "8px", sx: {
                    color: spinnerColor,
                } }, { children: text })))] })));
};
Spinner.defaultProps = {
    size: 60,
    testId: 'spinner-component',
};
export default Spinner;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3Bpbm5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NvbW1vbnMvU3Bpbm5lci9TcGlubmVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQzNDLE9BQU8sTUFBTSxNQUFNLGlCQUFpQixDQUFDO0FBR3JDLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUN2QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBQy9CLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFFL0IsTUFBTSxNQUFNLEdBQUcsU0FBUyxDQUFBOztDQUV2QixDQUFDO0FBRUYsTUFBTSxJQUFJLEdBQUcsU0FBUyxDQUFBOzs7Ozs7Ozs7Ozs7O0NBYXJCLENBQUM7QUFFRixNQUFNLFlBQVksR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFnRDtlQUNoRSxNQUFNOztXQUVWLENBQUMsRUFBRSxJQUFJLEVBQUUsRUFBRSxFQUFFLENBQUMsSUFBSTtZQUNqQixDQUFDLEVBQUUsSUFBSSxFQUFFLEVBQUUsRUFBRSxDQUFDLElBQUk7Y0FDaEIsQ0FBQyxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUM7O0NBRXRELENBQUM7QUFFRixNQUFNLE1BQU0sR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFBOzs7O2VBSWIsSUFBSTtDQUNsQixDQUFDO0FBU0YsTUFBTSxDQUFDLE1BQU0sT0FBTyxHQUFxQixDQUFDLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLEVBQUUsRUFBRTtJQUN6RSxNQUFNLFlBQVksR0FBRyxLQUFLLElBQUksS0FBSyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUM7SUFFcEQsT0FBTyxDQUNMLE1BQUMsSUFBSSxrQkFDSCxFQUFFLEVBQUU7WUFDRixVQUFVLEVBQUUsUUFBUTtZQUNwQixjQUFjLEVBQUUsUUFBUTtTQUN6QixpQkFDWSxNQUFNLGlCQUVuQixLQUFDLFlBQVksa0JBQUMsT0FBTyxFQUFDLFdBQVcsRUFBQyxJQUFJLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxPQUFPLENBQUMsSUFBSSxDQUFDLGdCQUNsRSxLQUFDLE1BQU0sSUFDTCxFQUFFLEVBQUMsSUFBSSxFQUNQLEVBQUUsRUFBQyxJQUFJLEVBQ1AsQ0FBQyxFQUFDLElBQUksRUFDTixJQUFJLEVBQUMsTUFBTSxFQUNYLFdBQVcsRUFBQyxHQUFHLEVBQ2YsTUFBTSxFQUFFLFlBQVksR0FDcEIsSUFDVyxFQUNkLElBQUksSUFBSSxDQUNQLEtBQUMsSUFBSSxrQkFDSCxFQUFFLEVBQUMsS0FBSyxFQUNSLEVBQUUsRUFBRTtvQkFDRixLQUFLLEVBQUUsWUFBWTtpQkFDcEIsZ0JBRUEsSUFBSSxJQUNBLENBQ1IsS0FDSSxDQUNSLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixPQUFPLENBQUMsWUFBWSxHQUFHO0lBQ3JCLElBQUksRUFBRSxFQUFFO0lBQ1IsTUFBTSxFQUFFLG1CQUFtQjtDQUM1QixDQUFDO0FBRUYsZUFBZSxPQUFPLENBQUMifQ==